export default __webpack_public_path__ + "static/media/rocket.45a77be3.png";